import type { MouseEvent, MutableRefObject, TouchEvent } from 'react';

type TouchPoint = Readonly<{ x: number; y: number }>;

export const TOUCH_SCROLL_GUARD_THRESHOLD_PX = 8;

export const handleTouchStartForScrollGuard = <TElement extends HTMLElement>(
  event: TouchEvent<TElement>,
  touchStartRef: MutableRefObject<TouchPoint | null>,
  hasTouchMovedRef: MutableRefObject<boolean>
): void => {
  const touch = event.touches[0];
  if (!touch) {
    return;
  }

  touchStartRef.current = { x: touch.clientX, y: touch.clientY };
  hasTouchMovedRef.current = false;
};

export const handleTouchMoveForScrollGuard = <TElement extends HTMLElement>(
  event: TouchEvent<TElement>,
  touchStartRef: MutableRefObject<TouchPoint | null>,
  hasTouchMovedRef: MutableRefObject<boolean>,
  thresholdPx = TOUCH_SCROLL_GUARD_THRESHOLD_PX
): void => {
  const touch = event.touches[0];
  if (!touch || !touchStartRef.current) {
    return;
  }

  const deltaX = Math.abs(touch.clientX - touchStartRef.current.x);
  const deltaY = Math.abs(touch.clientY - touchStartRef.current.y);

  if (deltaX > thresholdPx || deltaY > thresholdPx) {
    hasTouchMovedRef.current = true;
  }
};

export const resetTouchScrollGuard = (touchStartRef: MutableRefObject<TouchPoint | null>): void => {
  touchStartRef.current = null;
};

export const handleClickWithTouchScrollGuard = <TElement extends HTMLElement>(
  event: MouseEvent<TElement>,
  hasTouchMovedRef: MutableRefObject<boolean>,
  onClick?: () => void
): void => {
  if (hasTouchMovedRef.current) {
    event.preventDefault();
    event.stopPropagation();
    hasTouchMovedRef.current = false;
    return;
  }

  onClick?.();
};
